import ApiService from '@zola-helpers/client/dist/es/http/api';
import type { WModuleGroupViewList, WModuleView } from '@zola/svc-web-api-ts-client';

export function getModuleGroupByTag(tag: string): Promise<WModuleView> {
  return ApiService.get(`/website-nav/web-api/v1/moduleGroups/${tag}`);
}

export function getModuleGroupsList(tags: string[]): Promise<WModuleGroupViewList> {
  const queries = tags.map((tag) => `tags=${tag}`).join('&');
  return ApiService.get(`/website-nav/web-api/v1/moduleGroups/tags?${queries}`);
}
